import { render } from "./px-spinner.vue?vue&type=template&id=3d87ab1a&scoped=true"
const script = {}

import "./px-spinner.vue?vue&type=style&index=0&id=3d87ab1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d87ab1a"]])

export default __exports__